import { Injectable, signal } from '@angular/core';

@Injectable()
export class GlobalSideNavService {
  isOpen = signal(false);

  close() {
    this.isOpen.set(false);
  }

  open() {
    this.isOpen.set(true);
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }
}
